/* eslint-disable */
import PropTypes from 'prop-types';
import React, { useState } from 'react';
import { Tabs, Tab } from 'react-bootstrap';

// Main components below
import TabsUI from 'components/UI/TabsUI';

// Tab components
import ItemInventory from './Tabs/ItemInventory';
import ReturnedItemFromPatient from './Tabs/ReturnedItemFromPatient';
import ReturnedItemToInventory from './Tabs/ReturnedItemToInventory';

// Assets
import './style.scss';

// Main component
const DepartmentInventory = ({ departmentID }) => {
  const tabs = [
    {
      title: 'Item Inventory',
      component: ItemInventory,
    },
    {
      title: 'Returned Item to inventory',
      component: ReturnedItemToInventory,
    },
    {
      title: 'Returned Item from patient',
      component: ReturnedItemFromPatient,
    },
  ];

  return (
    <div className='doctorTabs'>
      <TabsUI>
        <Tabs defaultActiveKey={tabs[0].title}>
          {tabs.map(({ title, component: Component }, idx) => (
            <Tab key={idx} eventKey={title} title={title}>
              <Component departmentID={departmentID} />
            </Tab>
          ))}
        </Tabs>
      </TabsUI>
    </div>
  );
};

DepartmentInventory.defaultProps = {
  departmentID: '',
};

DepartmentInventory.propTypes = {
  departmentID: PropTypes.string,
};

export default DepartmentInventory;
